export const roleConfigs = {
    'ux-designer': {
      icon: 'Palette',
      color: 'purple',
      title: 'UX Designer',
      description: 'Design user-centered experiences'
    },
    'ui-designer': {
      icon: 'Palette',
      color: 'purple',
      title: 'UI Designer',
      description: 'Create beautiful user interfaces'
    },
    'product-designer': {
      icon: 'Palette',
      color: 'purple',
      title: 'Product Designer',
      description: 'Design end-to-end product experiences'
    },
    'frontend': {
      icon: 'Code',
      color: 'blue',
      title: 'Frontend Developer',
      description: 'Build amazing user interfaces'
    },
    'backend': {
      icon: 'Code',
      color: 'blue',
      title: 'Backend Developer',
      description: 'Build robust server applications'
    },
    'fullstack': {
      icon: 'Code',
      color: 'blue',
      title: 'Full Stack Developer',
      description: 'Build end-to-end applications'
    },
    'mobile': {
      icon: 'Smartphone',
      color: 'blue',
      title: 'Mobile Developer',
      description: 'Build mobile applications'
    },
    'product-manager': {
      icon: 'BarChart3',
      color: 'green',
      title: 'Product Manager',
      description: 'Drive product strategy and execution'
    },
    'product-owner': {
      icon: 'Users',
      color: 'green',
      title: 'Product Owner',
      description: 'Manage product backlog and stakeholders'
    },
    'ux-researcher': {
      icon: 'User',
      color: 'purple',
      title: 'UX Researcher',
      description: 'Research user needs and behaviors'
    },
    'content-designer': {
      icon: 'FileText',
      color: 'purple',
      title: 'Content Designer',
      description: 'Create user-focused content and copy'
    },
    'devops': {
      icon: 'Settings',
      color: 'orange',
      title: 'DevOps Engineer',
      description: 'Automate and scale infrastructure'
    },
    'qa': {
      icon: 'Shield',
      color: 'red',
      title: 'QA Engineer',
      description: 'Ensure quality and reliability'
    }
  };

// Icon mapping for components that need actual icon components
export const getIconComponent = (iconName) => {
  const iconMap = {
    'Palette': 'Palette',
    'Code': 'Code', 
    'Smartphone': 'Smartphone',
    'BarChart3': 'BarChart3',
    'Users': 'Users',
    'User': 'User',
    'FileText': 'FileText',
    'Settings': 'Settings',
    'Shield': 'Shield',
    'CheckCircle': 'CheckCircle',
    'Search': 'Search'
  };
  return iconMap[iconName] || 'Users';
};